const brandStyles = {
  tempo: {
    icon: {
      fill: 'var(--tempo-blue-70)',
      stroke: 'var(--tempo-black-100)',
      disabled: {
        fill: 'var(--white-100)',
        stroke: 'var(--charcoal-70)',
      },
    },
  },
  homechef: {
    icon: {
      fill: 'var(--green-70)',
      stroke: 'var(--green-130)',
      disabled: {
        fill: 'var(--white-100)',
        stroke: 'var(--charcoal-70)',
      },
    },
  },
};

const getBrandStylesheet = brand => {
  return brandStyles[brand];
};

export default getBrandStylesheet;
